<template>
  <!-- Eine kompakte Zeile statt Titelzeile + Breadcrumb-Zeile (~113px):
       Desktop zeigt den Breadcrumb (dessen aktiver Eintrag ist der Titel),
       Mobile nur den Seitentitel. -->
  <CHeader ref="headerRef" position="fixed" class="app-header-compact">
    <CContainer fluid>
      <!-- CoreUIs natives CSS-Burger-Icon - das FA-Kit ist kuratiert und
           enthaelt kein fa-bars -->
      <CHeaderToggler
        class="ps-1 pe-3"
        aria-label="Menü umschalten"
        @click="$store.commit('toggleSidebar')"
      >
        <span class="header-toggler-icon"></span>
      </CHeaderToggler>

      <h1 class="page-title d-md-none mb-0">{{ title }}</h1>
      <AppBreadcrumb class="d-none d-md-flex" />
    </CContainer>
  </CHeader>
</template>

<script>
import AppBreadcrumb from './AppBreadcrumb.vue'
import { onMounted, onBeforeUnmount, ref } from 'vue'
import router from '@/router'

export default {
  name: 'AppHeader',
  components: {
    AppBreadcrumb,
  },

  setup() {
    const title = ref()
    const headerRef = ref(null)
    let observer = null

    const getTitle = () => {
      return router.currentRoute.value.name
    }

    router.afterEach(() => {
      title.value = getTitle()
    })

    // Die Leiste liegt fest und nimmt am Scrollen nicht teil; damit sie den
    // Seitenanfang nicht verdeckt, braucht der Inhalt ihre Hoehe als Abstand.
    // Gemessen statt festgeschrieben: mobil traegt die Leiste den Seitentitel,
    // auf dem Desktop den Breadcrumb, und beides darf wachsen.
    const publishHeight = (height) => {
      document.documentElement.style.setProperty('--app-header-height', `${Math.round(height)}px`)
    }

    onMounted(() => {
      title.value = getTitle()

      const element = headerRef.value?.$el
      if (!element) {
        return
      }

      // Gemessen wird die Aussenkante: contentRect liesse die Innenabstaende
      // der Leiste weg, und der Inhalt ruecke um genau diese Differenz zu hoch.
      publishHeight(element.getBoundingClientRect().height)
      observer = new ResizeObserver(() =>
        publishHeight(element.getBoundingClientRect().height))
      observer.observe(element)
    })

    onBeforeUnmount(() => {
      observer?.disconnect()
      observer = null
    })

    return {
      title: title,
      headerRef,
    }
  },
}
</script>

<style scoped>
/* CoreUI kennt die Klasse header-fixed, liefert aber kein CSS dazu. Die Leiste
   spannt zwischen den Seitenleisten auf, genau wie die Speicherleiste der
   Zuordnungsansicht - sticky haette sie Teil des gescrollten Bereichs gelassen,
   und am Seitenende wandert der beim Ueberscrollen sichtbar mit. */
.app-header-compact.header-fixed {
  position: fixed;
  top: 0;
  left: var(--cui-sidebar-occupy-start, 0);
  right: var(--cui-sidebar-occupy-end, 0);
  z-index: 1030;
}

.page-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
}

/* Der aktive Breadcrumb-Eintrag IST der Seitentitel */
.app-header-compact :deep(.breadcrumb) {
  margin-bottom: 0;
}

.app-header-compact :deep(.breadcrumb-item.active) {
  font-weight: 600;
}
</style>
